(() => {
  let section = document.querySelector('.product-recommendations');
  let placeholder = document.querySelector('.product-recommendations__placeholder');
  if (!section || !section.dataset.url) return;

  const markProductCardsLoaded = (container) => {
    container.querySelectorAll('.product-card').forEach((card) => {
      const img = card.querySelector('img');
      if (!img) {
        card.classList.add('is-loaded');
        return;
      }
      const markLoaded = () => card.classList.add('is-loaded');
      if (img.complete && img.naturalWidth !== 0) {
        markLoaded();
      } else {
        img.addEventListener('load', markLoaded, { once: true });
        img.addEventListener('error', markLoaded, { once: true });
      }
    });
  };

  const loadRecommendations = () => {
    fetch(section.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const dom = document.createElement('div');
        dom.innerHTML = html;

        const freshSection = dom.querySelector('.product-recommendations');
        if (!freshSection || !freshSection.innerHTML.trim()) return;

        // Swap in the fetched results (swiper + bar-style scrollbar) as a unit,
        // keeping the header row + nav arrows rendered on first paint. Falls back
        // to the old placeholder→swiper swap for cached markup without the wrapper.
        const freshResults = freshSection.querySelector('[data-recommendations-results]');
        const results = section.querySelector('[data-recommendations-results]');

        if (freshResults && results) {
          results.replaceWith(freshResults);
        } else {
          const placeholder = section.querySelector('.product-recommendations__placeholder');
          const slider = freshSection.querySelector('.productSwiper');
          if (placeholder && slider) placeholder.replaceWith(slider);
        }

        // Init Swiper for this section — wires the arrows/scrollbar now in place.
        if (window.initSliders) {
          window.initSliders(section);
        }

        // Mark skeletons loaded
        markProductCardsLoaded(section);
      })
      .catch(console.error);
  };

  // Use requestIdleCallback if available, fallback to setTimeout
  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadRecommendations, { timeout: 1000 });
  } else {
    setTimeout(loadRecommendations, 500); // slight delay after page load
  }
})();
